const FooterComponent = () => {
    return (
        <>
            <div className="footer-part" id="footer">
                <div className="container-fluid">
                    <h3 className="footer">Made with ❤️</h3>
                    <h4 className="footer">by Muskaan Mahajan</h4>
                </div>
            </div>
        </>
    );
}

export default FooterComponent;